import React, { Fragment } from 'react';
import styled from 'styled-components';

// Storybook reference: https://ui-standard.hackhub.com/?path=/story/event-styleguide-labels--labels

export const CategoryLabel = styled.span`
    background: #CCEAFE;
    border-radius: ${(props) => (props.isRound ? '16.5px' : '6px')};
    color: #0094FB;
    font-family: 'Quicksand';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 2em;
    text-align: center;
    padding: 0.1em 0.4em;
    margin: 0.4em;
    
    @media only screen and (max-width: 768px) {
    font-size: 12px;
  }
`;

export const LabelStyle = styled.span`
    background: #F2711C;
    border-radius: 6px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    text-align: center;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    padding: 0.4em 0.9em;
    text-transform: uppercase;
    margin: 0.4em;
    display: inline-block;
    @media only screen and (max-width: 768px) {
    font-size: 12px;
  }
`;

export const ProgressLabel = styled(LabelStyle)`
    background: ${(props) => (props.isInProgress ? '#F2711C' : '#384455')};
    font-size: 16px;
    line-height: 19px;
`;

export const TeamLabel = styled(LabelStyle)`
    font-size: 12px;
    line-height: 15px;
`;

export const Label = ({
  category, isRound, isInProgress, label
}) => {
  if (category === 'category') {
    return (
      <CategoryLabel isRound={!!isRound}>
        {label}
      </CategoryLabel>
    );
  }

  if (category === 'team') {
    return <TeamLabel>{label}</TeamLabel>;
  }

  return (
    <Fragment>
      {isInProgress ?
        <ProgressLabel isInProgress={isInProgress}>
          {label}
        </ProgressLabel>
                : <ProgressLabel isInProgress={isInProgress}>{label}</ProgressLabel> }
    </Fragment>
  );
};

Label.defaultProps = {
  category: 'progress',
  label: 'Ended'
};



// WEBPACK FOOTER //
// ./src/uiStandard/event/label.js